/**
 * loggingHelper.js
 * Created by michaelbray on 2/14/18.
 */

import fetch from 'isomorphic-fetch';

export function log(message) {
    // first 9k message characters
    const body = {
        message: message.slice(0, 9000)
    };

    return fetch(`/log`, {
        method: 'POST',
        body: JSON.stringify(body)
    })
        .then((response) => {
            if (response.status !== 200) {
                // console.log('Error logging message ' + message);
            }
        });
}

export function logError(message, error) {
    let err = error;

    if (!error) {
        err = new Error();
    }
    const stack = err.stack;
    // first 9k message characters
    const body = {
        error: message.slice(0, 2000),
        stack: (`${stack}`).slice(0, 7000)
    };

    return fetch(`/log`, {
        method: 'POST',
        body: JSON.stringify(body)
    })
        .then((response) => {
            if (response.status !== 200) {
                // console.log('Error logging message ' + message);
            }
        });
}
